import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icon } from 'semantic-ui-react';
import i18next from 'i18next';
import { DataGrid } from '../../common';
import WebsiteAccessKeyEditor from './WebsiteAccessKeyEditor';
import SideEditor from '../../general/SideEditor';
import { setEditedEntity, saveWebsite, confirmDelete } from '../../../actions';
import { uploadExcelData } from '../../../helpers/excel';

const WebsiteAccessKeys = ({ branchId }) => {
    const dispatch = useDispatch();
    const chainId = useSelector(state => state.businessApp.chainId);
    const website = useSelector(state => state.businessApp.website);
    const isOnEdit = useSelector(state => state.editor.type === 'websiteAccessKey');
    const websiteHref =  useSelector(state => `${state.meta.webappUrl || 'https://orders.paidit.io/'}?chainId=${chainId}`);

    function generateAccessLink(accessKey) {
        return `${websiteHref}&wak=${accessKey}`;
    }

    if (!website) return null;

    const handleUploadChange = (e) => {
        try {
            const files = e.target.files;
            if (files && files[0]) {
                uploadExcelData(files[0], (data) => {
                    const accessKeysToAdd = [];
                    for (let row = 1; row < data.length; row++) {
                        const rowData = data[row];

                        if (rowData.length) {
                            const tableNumber = String(rowData[0]);
                            const accessKey = String(rowData[1]);

                            if (tableNumber && accessKey) {
                                accessKeysToAdd.push({ chainId, branchId, tableNumber, accessKey });
                            }
                        }
                    }

                    if (accessKeysToAdd.length) {
                        dispatch(saveWebsite({ id: website.id, accessKeysToAdd }));
                    }
                });
            }
        } catch (error) {
            window.location.reload();
            alert('Failed to handle file');
        }
    };

    const handleDelete = wak => {
        dispatch(confirmDelete(wak.accessKey, () => {
            dispatch(saveWebsite({ id: website.id, accessKeysToRemove: [wak.id] }));
        }));
    };

    const renderActions = () => {
        let uploader;

        return (
            <div>
                <input
                    type='file'
                    accept=".xlsx, .xls"
                    ref={(ref) => uploader = ref}
                    onChange={handleUploadChange}
                    style={{ display: "none" }}
                />
                <Button
                    icon='file excel outline'
                    labelPosition='left'
                    content={i18next.t('excel.load')}
                    onClick={() => uploader.click()}
                />
                <Button
                    icon
                    labelPosition='left'
                    floated="right"
                    primary
                    onClick={() => dispatch(setEditedEntity('websiteAccessKey', { chainId, branchId }))}
                >
                    <Icon name='add' /> {i18next.t('create')}
                </Button>
            </div>
        );
    };

    const columns = [{
        Header: i18next.t('website.accessKey'),
        accessor: 'accessKey',
        maxWidth: 100,
        filterable: true
    }, {
        Header: i18next.t('tableNumber'),
        accessor: 'tableNumber',
        maxWidth: 100,
        filterable: true
    }, {
        id: 'Link',
        Header: i18next.t('website.link'),
        accessor: wak => generateAccessLink(wak.accessKey),
        filterable: true,
        Cell: row => {
            const href = generateAccessLink(row.original.accessKey);
            return <a target='_blank' rel="noopener noreferrer" href={href}>{href}</a>;
        }
    }, {
        id: 'actions',
        Header: i18next.t('actions'),
        maxWidth: 80,
        sortable: false,
        filterable: false,
        Cell: row => {
            const wak = row.original;

            return (
                <div>
                    <Button circular size='tiny' icon='write' basic onClick={() => dispatch(setEditedEntity('websiteAccessKey', wak))} />
                    <Button circular size='tiny' icon='trash' negative onClick={() => handleDelete(wak)} />
                </div>
            );
        }
    }];

    const accessKeys = website.accessKeys.filter(wak => wak.branchId == branchId);

    return (
        <div style={{ padding: 10 }}>
            <SideEditor
                title={i18next.t('website.accessKey')}
                visible={isOnEdit}
                handleClose={() => dispatch(setEditedEntity(null))}
            >
                <WebsiteAccessKeyEditor websiteId={website.id} />
            </SideEditor>

            <DataGrid
                data={accessKeys}
                columns={columns}
                getTrGroupProps={(state, rowInfo, column) => {
                    return {};
                }}
                extraActions={renderActions()}
                paginated
                pageSize={10}
            />
        </div>
    );
};

export default WebsiteAccessKeys;